import { Link } from "react-router-dom";
import TopBar from "../../components/topBar/topBar";
import BookIcon from './book.svg';
import AddIcon from './add.svg';

function Dashboard () {
    return (
        <div className="min-h-screen">
            <TopBar logo={true} />
            <div className="mx-auto max-w-5xl px-4 sm:px-6 py-10">
                <h1 className="mb-10 text-2xl font-light text-mainDark">Dashboard</h1>
                <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
                    <Link
                        to="/new-book"
                        className="group flex flex-col items-center gap-4 rounded-2xl border border-mainDark/30 bg-mainWhite p-8 shadow-result transition-all duration-200 hover:shadow-result-hover hover:-translate-y-0.5 active:translate-y-0"
                    >
                        <img src={AddIcon} alt="add icon" className="h-10 w-10 opacity-60 transition-opacity duration-200 group-hover:opacity-100" />
                        <span className="text-base font-light text-mainDark uppercase tracking-wide">Add entry</span>
                    </Link>
                    <Link
                        to="/view-books"
                        className="group flex flex-col items-center gap-4 rounded-2xl border border-mainDark/30 bg-mainWhite p-8 shadow-result transition-all duration-200 hover:shadow-result-hover hover:-translate-y-0.5 active:translate-y-0"
                    >
                        <img src={BookIcon} alt="book icon" className="h-10 w-10 opacity-60 transition-opacity duration-200 group-hover:opacity-100" />
                        <span className="text-base font-light text-mainDark uppercase tracking-wide">View Books</span>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
